package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class HashtagDto(
    @SerialName("hashtag") val hashtag: String,
    @SerialName("post_count") val postCount: Int
)

@Serializable
data class HashtagListResponse(
    @SerialName("data") val data: HashtagListData
)

@Serializable
data class HashtagListData(
    @SerialName("hashtags") val hashtags: List<HashtagDto> = emptyList()
)

@Serializable
data class HashtagPostsResponse(
    @SerialName("data") val data: HashtagPostsData
)

@Serializable
data class HashtagPostsData(
    @SerialName("items") val items: List<PostDtoV2> = emptyList(),
    @SerialName("next_cursor") val nextCursor: String? = null
)
